import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const RouterView = {
  template: '<router-view ></router-view >',
}

const routes = [
  {
    path: '/',
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: '/login',
        component: () => import('@/views/login/login.vue'),
      },
      {
        path: '/regist',
        component: () => import('@/views/login/regist.vue'),
      },
      {
        path: '/reset',
        component: () => import('@/views/login/reset.vue'),
      },
      {
        path: 'usercenter',
        component: () => import('@/views/usercenter.vue'),
        children: [
          {
            path: '',
            redirect: 'todo',
          },
          {
            path: 'todo',
            name: '我的待办',
            component: () => import('@/views/todo.vue'),
          },
          {
            path: 'project',
            name: '我的项目',
            component: RouterView,
            children: [
              {
                path: '',
                redirect: 'list',
              },
              {
                path: 'list',
                name: '项目列表',
                component: () => import('@/views/project/list.vue'),
              },
              {
                path: 'funded',
                name: '合作项目',
                component: RouterView,
                children: [
                  {
                    path: 'draft',
                    name: '申报合作项目',
                    component: () => import('@/views/project/funded/draft.vue'),
                  },
                  {
                    path: 'raise',
                    name: '筹款申请',
                    component: () => import('@/views/project/funded/raise.vue'),
                  },
                  {
                    path: 'makeplan',
                    name: '制定计划',
                    component: () => import('@/views/project/funded/makeplan.vue'),
                  },
                  {
                    path: 'report',
                    name: '项目报告',
                    component: RouterView,
                    children: [
                      {
                        path: 'draft',
                        name: '填报项目进展报告',
                        component: () => import('@/views/project/funded/report/draft.vue'),
                      },
                      {
                        path: 'detail',
                        name: '项目进展报告详情',
                        component: () => import('@/views/project/funded/report/detail.vue'),
                      },
                    ],
                  },
                  {
                    path: 'changeinfo',
                    name: '项目变更',
                    component: RouterView,
                    children: [
                      {
                        path: 'draft',
                        name: '填报项目变更',
                        component: () => import('@/views/project/funded/changeinfo/draft.vue'),
                      },
                      {
                        path: 'detail',
                        name: '项目变更详情',
                        component: () => import('@/views/project/funded/changeinfo/detail.vue'),
                      },
                    ],
                  },
                  {
                    path: 'applybill',
                    name: '财务请款单',
                    component: RouterView,
                    children: [
                      {
                        path: 'draft',
                        name: '填报财务请款单',
                        component: () => import('@/views/project/funded/applybill/draft.vue'),
                      },
                      {
                        path: 'detail',
                        name: '财务请款单详情',
                        component: () => import('@/views/project/funded/applybill/detail.vue'),
                      },
                    ],
                  },
                  {
                    path: 'progress',
                    name: '财务进展数据',
                    component: RouterView,
                    children: [
                      {
                        path: 'draft',
                        name: '填报财务进展数据',
                        component: () => import('@/views/project/funded/progress/draft.vue'),
                      },
                      {
                        path: 'detail',
                        name: '财务进展数据详情',
                        component: () => import('@/views/project/funded/progress/detail.vue'),
                      },
                    ],
                  },
                  {
                    path: 'view',
                    name: '项目详情',
                    component: () => import('@/views/project/funded/view.vue'),
                    children: [
                      {
                        path: '',
                        redirect: 'basic',
                      },
                      {
                        path: 'basic',
                        name: '项目信息',
                        component: () => import('@/views/project/funded/view/basic.vue'),
                      },
                      {
                        path: 'budget',
                        name: '项目预算表',
                        component: () => import('@/views/project/funded/view/budget.vue'),
                      },
                      {
                        path: 'plan',
                        name: '项目计划',
                        component: () => import('@/views/project/funded/view/plan.vue'),
                      },
                      {
                        path: 'finance',
                        name: '财务信息',
                        component: () => import('@/views/project/funded/view/finance.vue'),
                      },
                      {
                        path: 'report',
                        name: '项目报告',
                        component: () => import('@/views/project/funded/view/report.vue'),
                      },
                      {
                        path: 'raise',
                        name: '筹款申请',
                        component: () => import('@/views/project/funded/view/raise.vue'),
                      },
                      {
                        path: 'changeinfo',
                        name: '项目变更',
                        component: () => import('@/views/project/funded/view/changeinfo.vue'),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'house',
                name: '螺蛳壳改造项目',
                component: RouterView,
                children: [
                  {
                    path: 'budget',
                    name: '提交项目预算表',
                    component: () => import('@/views/project/house/budget.vue'),
                  },
                  {
                    path: 'report',
                    name: '项目报告',
                    component: RouterView,
                    children: [
                      {
                        path: 'draft',
                        name: '填报项目进展报告',
                        component: () => import('@/views/project/house/report/draft.vue'),
                      },
                      {
                        path: 'detail',
                        name: '项目进展报告详情',
                        component: () => import('@/views/project/house/report/detail.vue'),
                      },
                    ],
                  },
                  {
                    path: 'changeinfo',
                    name: '项目变更',
                    component: RouterView,
                    children: [
                      {
                        path: 'draft',
                        name: '填报项目变更',
                        component: () => import('@/views/project/house/changeinfo/draft.vue'),
                      },
                      {
                        path: 'detail',
                        name: '项目变更详情',
                        component: () => import('@/views/project/house/changeinfo/detail.vue'),
                      },
                    ],
                  },
                  {
                    path: 'applybill',
                    name: '财务请款单',
                    component: RouterView,
                    children: [
                      {
                        path: 'draft',
                        name: '填报财务请款单',
                        component: () => import('@/views/project/house/applybill/draft.vue'),
                      },
                      {
                        path: 'detail',
                        name: '财务请款单详情',
                        component: () => import('@/views/project/house/applybill/detail.vue'),
                      },
                    ],
                  },
                  {
                    path: 'progress',
                    name: '财务进展数据',
                    component: RouterView,
                    children: [
                      {
                        path: 'draft',
                        name: '填报财务进展数据',
                        component: () => import('@/views/project/house/progress/draft.vue'),
                      },
                      {
                        path: 'detail',
                        name: '财务进展数据详情',
                        component: () => import('@/views/project/house/progress/detail.vue'),
                      },
                    ],
                  },
                  {
                    path: 'view',
                    name: '项目详情',
                    component: () => import('@/views/project/house/view.vue'),
                    children: [
                      {
                        path: '',
                        redirect: 'basic',
                      },
                      {
                        path: 'basic',
                        name: '项目信息',
                        component: () => import('@/views/project/house/view/basic.vue'),
                      },
                      {
                        path: 'plan',
                        name: '项目计划',
                        component: () => import('@/views/project/house/view/plan.vue'),
                      },
                      {
                        path: 'finance',
                        name: '财务信息',
                        component: () => import('@/views/project/house/view/finance.vue'),
                      },
                      {
                        path: 'report',
                        name: '项目报告',
                        component: () => import('@/views/project/house/view/report.vue'),
                      },
                      {
                        path: 'changeinfo',
                        name: '项目变更',
                        component: () => import('@/views/project/house/view/changeinfo.vue'),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'study',
                name: '精灵书屋项目',
                component: RouterView,
                children: [
                  {
                    path: 'report',
                    name: '项目报告',
                    component: RouterView,
                    children: [
                      {
                        path: 'draft',
                        name: '填报项目报告',
                        component: () => import('@/views/project/study/report/draft.vue'),
                      },
                      {
                        path: 'detail',
                        name: '项目报告详情',
                        component: () => import('@/views/project/study/report/detail.vue'),
                      },
                    ],
                  },
                  {
                    path: 'view',
                    name: '项目详情',
                    component: () => import('@/views/project/study/view.vue'),
                    children: [
                      {
                        path: '',
                        redirect: 'basic',
                      },
                      {
                        path: 'basic',
                        name: '项目信息',
                        component: () => import('@/views/project/study/view/basic.vue'),
                      },
                      {
                        path: 'report',
                        name: '项目报告',
                        component: () => import('@/views/project/study/view/report.vue'),
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: 'meeting',
            name: '会议表决',
            component: RouterView,
            children: [
              {
                path: '',
                redirect: 'list',
              },
              {
                path: 'list',
                name: '会议列表',
                component: () => import('@/views/meeting/list.vue'),
              },
              {
                path: 'vote',
                name: '会议投票',
                component: () => import('@/views/meeting/vote.vue'),
              },
              {
                path: 'view',
                name: '会议详情',
                component: () => import('@/views/meeting/view.vue'),
              },
            ],
          },
          {
            path: 'profile',
            name: '用户信息',
            component: () => import('@/views/profile.vue'),
          },
          { path: '*', name: '404', component: () => import('@/views/404.vue') },
        ],
      },
      { path: '*', redirect: '/login' },
    ],
  },
]

const router = new VueRouter({
  routes,
})

export default router
